"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenBtn = void 0;
var _FullscreenRounded = _interopRequireDefault(require("@mui/icons-material/FullscreenRounded"));
var _FullscreenExitRounded = _interopRequireDefault(require("@mui/icons-material/FullscreenExitRounded"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FullScreenBtn = _ref => {
  let {
    fullScreen,
    setFullScreen,
    opacity = 1,
    inFullScreen = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    sx: {
      position: 'absolute',
      zIndex: 2,
      top: 0,
      right: 0,
      backgroundColor: _constants.colors['main-color-cl-19'],
      borderRadius: _constants.styles.borderRadius.button,
      color: _constants.colors['main-color-cl-01'],
      transition: _constants.styles.transitionType.secondary,
      margin: inFullScreen ? '20px' : '9px',
      opacity,
      '&:hover': {
        backgroundColor: _constants.colors['main-color-cl-19'],
        opacity: 0.8
      }
    },
    onClick: () => setFullScreen(prev => !prev)
  }, fullScreen ? /*#__PURE__*/_react.default.createElement(_FullscreenExitRounded.default, null) : /*#__PURE__*/_react.default.createElement(_FullscreenRounded.default, null));
};
exports.FullScreenBtn = FullScreenBtn;
FullScreenBtn.propTypes = {
  opacity: _propTypes.default.number,
  inFullScreen: _propTypes.default.bool,
  fullScreen: _propTypes.default.bool.isRequired,
  setFullScreen: _propTypes.default.func.isRequired
};